import {
  AppsApiFactory as AppsPrivateApiFactory,
  TermsAndPolicyData,
} from '@flipdish/api-client-typescript/private/api';
import axios from 'axios';

import { getApiEndPoint } from '../../helpers/apibase';
import { createApi } from '../../helpers/utilities';
import { mapServerError } from '../../services/utils/serverErrorMapper';
import {
  AlphaSender,
  AvailableAlphaSendersResponse,
  GetAvailableAlphaSendersParams,
} from './settings.types';

const appsPrivateApi = createApi(AppsPrivateApiFactory);

const baseURL = getApiEndPoint();
export const communicationApi = axios.create({
  baseURL: `${baseURL}/communication`,
  withCredentials: true,
  timeout: 15000,
});

// #region TermsAndPolicyData
export const getTermsAndPolicyData = async (appId: string) => {
  try {
    const incomingMessage = await appsPrivateApi.getTermsAndPolicyData(appId);
    return incomingMessage;
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
};

export const setTermsAndPolicyData = async (
  appId: string,
  termsAndPolicyData: TermsAndPolicyData
) => {
  // try {
  const incomingMessage = await appsPrivateApi.editTermsAndPolicyData(appId, termsAndPolicyData);

  return incomingMessage;
  // TODO map server validation errors
  // } catch (e) {
  //   if (e && e.response && e.response.body && 'Errors' in e.response.body) {
  //     const errRes: RestApiErrorResult = e.response.body;
  //     console.log(errRes)
  //     debugger
  //   }
  //   throw mapServerError(e);
  // }
};
// #endregion

// #region AlphaSenders
export const getAvailableAlphaSenders = async (
  params?: GetAvailableAlphaSendersParams
): Promise<AvailableAlphaSendersResponse> => {
  try {
    const response = await communicationApi.get<AvailableAlphaSendersResponse>(
      '/alpha-senders/available',
      { params }
    );
    return response.data;
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
};

export const getValidatedSenderCountries = async (senderId: string): Promise<AlphaSender[]> => {
  try {
    const response = await communicationApi.get<AlphaSender[]>(
      `/alpha-senders/validated/${encodeURIComponent(senderId)}/countries`
    );
    return response.data;
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
};
// #endregion
